import React, { Component } from 'react'
import { connect } from 'react-redux'
import axios from 'axios'
import autobind from 'autobind-decorator'
import update from 'immutability-helper'
import { Button } from '@material-ui/core'
import PhotoList from './PhotoList'
import {initGooglePhotos, receiveGooglePhotosImages} from "../../../../actions/plugins";
import WindowEventHelper from "../../../../../../admin/src/lib/WindowEventHelper";

@connect(state => ({
  images: state.plugins.googlePhotos.images,
  nextPageToken: state.plugins.googlePhotos.nextPageToken,
  hasMore: state.plugins.googlePhotos.hasMore,
  connected: state.plugins.googlePhotos.connected,
  connectUrl: state.plugins.googlePhotos.connectUrl
}), dispatch => ({
  handleInitGooglePhotos(connectUrl) {
    dispatch(initGooglePhotos(connectUrl))
  },
  handleReceiveImages(images, nextPageToken) {
    dispatch(receiveGooglePhotosImages(images, nextPageToken))
  }
}))
class GooglePhotos extends Component {
  constructor(props, context) {
    super(props, context)
    this.state = {
      initialized: false,
      fetching: false,
    }
  }

  componentWillUnmount() {
    WindowEventHelper.remove("message", this.handleReceivePostMessage)
  }

  componentDidMount() {
    WindowEventHelper.add("message", this.handleReceivePostMessage)
    this.handleRequestFetch()
  }

  @autobind
  handleReceivePostMessage(e) {
    if (e.data && e.data.name === 'GoogleOAuth') {
      if (e.data.status === 'OK') {
        this.handleRequestFetch()
      }
    }
  }

  @autobind
  handleReceiveImages(e, data) {
    const { images, fetching } = this.state
    if (data === null) {
      this.handleDisconnect()
      return
    }

    this.setState({
      initialized: true,
      connected: true,
      images: update(images, {
        $push: data.images
      }),
      nextPageToken: data.nextPageToken,
      fetching: false
    })
  }

  @autobind
  handleReceiveConnected(e, connected) {
    if (connected) {
      this.setState({
        initialized: true,
        connected: true
      })
    } else {
      this.setState({
        initialized: true,
        images: [],
        nextPageToken: null,
        connected: false
      })
    }

  }

  @autobind
  handleStartFetch(e) {
    this.setState({
      fetching: true
    })
  }

  @autobind
  handleRequestFetch() {
    const { fetching } = this.state
    const { hasMore, nextPageToken, handleInitGooglePhotos, handleReceiveImages } = this.props

    if (!hasMore || fetching) {
      return;
    }
    this.setState({
      fetching: true
    })

    axios(`${appInfo.manageUrl}/post/plugins/google-photos.json`, {
      params: {
        nextPageToken: nextPageToken
      }
    })
      .then(r => {
        console.log(r)
        handleReceiveImages(r.data.images, r.data.nextPageToken)
      })
      .catch(e => {
        handleInitGooglePhotos(e.response.data.authUrl)
      })
      .finally(() => {
        this.setState({
          initialized: true,
          fetching: false
        })
      })

  }

  @autobind
  handleRequestAuth() {
    const { connectUrl } = this.props
    window.open(connectUrl, "_blank", "width=640px,height=480px,menubar=false,status=false")
  }

  @autobind
  handleDisconnect() {
    // TODO expire auth
  }

  @autobind
  handleImageSelect(image) {
    const { onSelectImage } = this.props
    if (confirm('이미지를 삽입하시겠습니까?')) {
      onSelectImage(image.url, image.title)
    }
  }

  render() {
    const { initialized, fetching } = this.state
    const { connected } = this.props

    if (!initialized) {
      return (
        <div className="google-photos-wrap">
          <div className="google-photos-cover">
            로딩 중
          </div>
        </div>
      )
    }

    if (!connected) {
      return (
        <div className="google-photos-wrap">
          <div className="google-photos-cover">
            <Button variant='contained' className='btn btn_tistory' onClick={this.handleRequestAuth}>
              Google Photos 연결
            </Button>
          </div>
        </div>
      )
    }

    return (
      <PhotoList fetching={fetching}
                 onFetch={this.handleRequestFetch}
                 onClick={this.handleImageSelect}
                 onDisconnect={this.handleDisconnect} />
    )
  }
}

export default GooglePhotos
